var map = {
	"./Ai_logo_header": 245,
	"./Ai_logo_header.svg": 245,
	"./agile-takeover-2025.jpg": 246,
	"./agile_banner_2026.png": 247,
	"./agile_takeover_1.png": 248,
	"./agile_takeover_2.png": 249,
	"./agile_takeover_3.png": 250,
	"./agile_takeover_4.png": 251,
	"./agile_takeover_5.png": 252,
	"./ai-button.png": 253,
	"./ai-cross-icon.png": 254,
	"./ai-file-icon.png": 255,
	"./ai-green-check.png": 256,
	"./ai-lock.png": 257,
	"./ai-summarization-button.png": 258,
	"./ai-summarize-disabled.png": 259,
	"./ai-takeover.png": 260,
	"./ai-thinking-bars.png": 261,
	"./ai-tour/aiTour1.png": 262,
	"./ai-tour/aiTour2.png": 263,
	"./ai-tour/aiTour3.png": 264,
	"./ai-tour/aiTour4.png": 265,
	"./ai-tour/aiTour5.png": 266,
	"./ai-tour/aiTour6.png": 267,
	"./ai-tour/axxess-intelligence-search": 268,
	"./ai-tour/axxess-intelligence-search.svg": 268,
	"./ai_footer": 269,
	"./ai_footer.svg": 269,
	"./ai_logo": 270,
	"./ai_logo.svg": 270,
	"./ai_summarization_logo": 271,
	"./ai_summarization_logo.svg": 271,
	"./ask-axxess-banner.png": 272,
	"./ask-axxess-text.png": 273,
	"./axxess-intelligence-input-logo": 274,
	"./axxess-intelligence-input-logo.svg": 274,
	"./axxess-intelligence-logo.png": 173,
	"./axxess-intelligence-premium-locked.png": 275,
	"./axxess-intelligence-premium-unlocked.png": 276,
	"./close": 277,
	"./close-icon.png": 242,
	"./close.svg": 277,
	"./cta-1.png": 278,
	"./cta-2.png": 279,
	"./cta-3.png": 280,
	"./cta-4.png": 281,
	"./cta-5.png": 282,
	"./cta-6.png": 283,
	"./favicon": 284,
	"./favicon-96x96.png": 165,
	"./favicon.svg": 284,
	"./filter": 285,
	"./filter.svg": 285,
	"./flags-lg.png": 286,
	"./flags.png": 287,
	"./form-builder/ai-sparkle.png": 288,
	"./form-builder/suicide-risk.png": 289,
	"./form-builder/wong-baker-scale.png": 290,
	"./hide_sidebar": 291,
	"./hide_sidebar.svg": 291,
	"./hope-page-takeover.jpg": 292,
	"./hospice-logo.png": 293,
	"./loader": 294,
	"./loader.svg": 294,
	"./logo": 295,
	"./logo-beta": 296,
	"./logo-beta-borderless-bold.png": 297,
	"./logo-beta-borderless-extrabold.png": 298,
	"./logo-beta-borderless-semibold.png": 299,
	"./logo-beta.png": 300,
	"./logo-beta.svg": 296,
	"./logo-beta1.png": 301,
	"./logo-beta2.png": 302,
	"./logo-beta3.png": 303,
	"./logo.png": 304,
	"./logo.svg": 295,
	"./most_searched_icon": 305,
	"./most_searched_icon.svg": 305,
	"./mrn-example.png": 306,
	"./placeholder.png": 307,
	"./recent_search_icon": 308,
	"./recent_search_icon.svg": 308,
	"./search_icon": 309,
	"./search_icon.svg": 309,
	"./suggestion_icon": 310,
	"./suggestion_icon.svg": 310,
	"./svg_ai-dp": 172,
	"./svg_ai-dp.svg": 172,
	"./tab": 311,
	"./tab.png": 312,
	"./tab.svg": 311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;